// Config de entorno. VITE_API_BASE_URL apunta al backend Spring (context-path /api).
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8084/api';
